import { useTheme } from '@mui/material';

export default function AvgResponseTimeIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill={theme.palette.primary.light} />
      <path
        d='M15.9969 8.81848C12.0403 8.81848 8.81738 12.0414 8.81738 15.998C8.81738 19.9546 12.0403 23.1775 15.9969 23.1775C19.9535 23.1775 23.1764 19.9546 23.1764 15.998C23.1764 12.0414 19.9535 8.81848 15.9969 8.81848ZM15.9969 10.2544C19.1775 10.2544 21.7405 12.8174 21.7405 15.998C21.7405 19.1786 19.1775 21.7416 15.9969 21.7416C12.8163 21.7416 10.2533 19.1786 10.2533 15.998C10.2533 12.8174 12.8163 10.2544 15.9969 10.2544ZM15.2789 11.6903V16.2952L18.3611 19.3774L19.3763 18.3622L16.7148 15.7007V11.6903H15.2789Z'
        fill={theme.palette.primary.main}
      />
    </svg>
  );
}
